
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/music-distribution",
      function () {
        return require("private-next-pages/music-distribution/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/music-distribution"])
      });
    }
  